import axios from "axios";
import { API_BASE } from "./apiBase";

const PENDING_KEY = "prelegal_pending_plan_v1";
const PENDING_GATEWAY_KEY = "prelegal_pending_gateway_v1";

export const setPendingPlan = (planCode, gateway = "") => {
  try {
    window.sessionStorage.setItem(PENDING_KEY, planCode);
    if (gateway) window.sessionStorage.setItem(PENDING_GATEWAY_KEY, gateway);
    else window.sessionStorage.removeItem(PENDING_GATEWAY_KEY);
  } catch { /* noop */ }
};

export const consumePendingPlan = () => {
  try {
    const plan = window.sessionStorage.getItem(PENDING_KEY) || "";
    const gateway = window.sessionStorage.getItem(PENDING_GATEWAY_KEY) || "";
    if (plan) window.sessionStorage.removeItem(PENDING_KEY);
    if (gateway) window.sessionStorage.removeItem(PENDING_GATEWAY_KEY);
    return { plan, gateway };
  } catch {
    return { plan: "", gateway: "" };
  }
};

const _normalizeError = (err) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return "No se pudo iniciar el pago. Intenta de nuevo.";
};

/**
 * Start a Flow.cl subscription checkout.
 * Redirects to Flow's hosted card capture page on success.
 */
export async function startFlowCheckout(planCode) {
  try {
    const { data } = await axios.post(
      `${API_BASE}/api/payments/checkout`,
      { plan_code: planCode },
      { withCredentials: true }
    );
    if (data?.url) {
      window.location.href = data.url;
      return { ok: true };
    }
    return { ok: false, error: "Flow.cl no devolvió URL de pago." };
  } catch (err) {
    return { ok: false, error: _normalizeError(err) };
  }
}

/**
 * Start a Mercado Pago subscription checkout (preapproval).
 * Redirects to MP's hosted authorization page on success.
 */
export async function startMpCheckout(planCode) {
  try {
    const { data } = await axios.post(
      `${API_BASE}/api/payments/mp/checkout`,
      { plan_code: planCode },
      { withCredentials: true }
    );
    if (data?.url) {
      window.location.href = data.url;
      return { ok: true };
    }
    return { ok: false, error: "Mercado Pago no devolvió URL de pago." };
  } catch (err) {
    return { ok: false, error: _normalizeError(err) };
  }
}

/**
 * Generic dispatcher.  gateway: "flow" | "mp"
 */
export async function startCheckout(planCode, gateway) {
  if (gateway === "mp") return startMpCheckout(planCode);
  return startFlowCheckout(planCode);
}
